/* eslint-disable react/no-unknown-property */
/* eslint-disable max-len */
import React from 'react';

/**
 * SlideInboxIcon - Auto-generated from icon.js
 */
export const SlideInboxIcon = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
	<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
		<path d="M18.3337 10H13.3337L11.667 12.5H8.33366L6.66699 10H1.66699" stroke="#333333" strokeLinecap="round" strokeLinejoin="round" />
		<path d="M4.54199 4.25833L1.66699 10V15C1.66699 15.442 1.84259 15.8659 2.15515 16.1785C2.46771 16.4911 2.89163 16.6667 3.33366 16.6667H16.667C17.109 16.6667 17.5329 16.4911 17.8455 16.1785C18.1581 15.8659 18.3337 15.442 18.3337 15V10L15.4587 4.25833C15.3207 3.98065 15.108 3.74697 14.8445 3.58357C14.5809 3.42016 14.2771 3.3335 13.967 3.33333H6.03366C5.72359 3.3335 5.41971 3.42016 5.1562 3.58357C4.89268 3.74697 4.67997 3.98065 4.54199 4.25833Z" stroke="#333333" strokeLinecap="round" strokeLinejoin="round" />
	</svg>
);

export default SlideInboxIcon;
